module.exports = __webpack_public_path__ + "img/rimessa_logo_rosso.a5c1acac.png";